const config = {
    'searchList': {
        'searchTxt': [
            {
                'name': '整改月份',
                'value': 'month',
                'type': 'time',
                'timeType': 'month',
                'placeholder': '整改月份',
                'unfold': true,
                'format': 'yyyy-MM',
                'span': 4,
            },
            {
                name: '整改单号',
                value: 'rectificationPlanCode',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '分公司',
                value: 'companyName',
                type: 'advance',
                advanceUrl: '/esCompany/popCompany',
                unfold: true,
                searchRequired: true,
                span: 3,
                advanceLabel: '分公司弹出框',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
            },
            {
                name: '经营中心',
                value: 'businessCenterName',
                type: 'input',
                unfold: true,
                span: 3,
                visible: '2,3,6,7',
            },
            {
                name: '服务平台',
                value: 'siteName',
                type: 'advance',
                unfold: true,
                searchRequired: true,
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                ],
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                span: 3,
                advanceCascade: `companyCode#companyCode`,
                visible: '2,3',
            },
            {
                'name': '内外部客户',
                'value': 'customerType',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '内部客户', value: '1' },
                    { label: '外部客户', value: '2' },
                ],
                'span': 4,
                'visible': '3,5,7',
            },
            {
                'name': '供应商编码',
                'value': 'supplierCode',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '供应商名称',
                'value': 'supplierNameCn',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '业务类型',
                'value': 'businessType',
                'type': 'select',
                'unfold': true,
                'options': [
                    {'label': '运输', 'value': '3'},
                    {'label': '配送', 'value': '4'},
                    {'label': '配送(新)', 'value': '5'},
                ],
                'span': 4
            },
            {
                'name': '绩效等级',
                'value': 'performanceStarRating',
                'type': 'select',
                'unfold': true,
                'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                'options': [],
                'span': 3
            },
            {
                'name': '整改跟进人',
                'value': 'mipName',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '下发状态',
                'value': 'rectificationSendStatus',
                'type': 'select',
                'unfold': true,
                'optionNum': 'RECTIFICATION_SEND_STATUS',
                'options': [],
                'span': 3
            },
            {
                'name': '整改提交',
                'value': 'isSubmitRectificationPlan',
                'type': 'select',
                'unfold': true,
                'options': [
                    { label: '待提交', value: '1' },
                    { label: '已提交', value: '2' },
                ],
                'span': 4
            },
            {
                'name': '次月整改状况',
                'value': 'nextRectificationType',
                'type': 'select',
                'unfold': true,
                'optionNum': 'PERFORMANCE_NEXT_MONTH_STATUS',
                'options': [],
                'span': 4
            },
        ],
        'unfoldState': false,
        'advancedBtn': true,
        'resetBtn': true
    },
    'table':  {
        'selectBtn': true,
        'leftOperation': true,
        'leftWidth': 160,
        'height': 'calc(100vh - 272px)',
        'columns': [
            {
                'label': '整改单号',
                'prop': 'rectificationPlanCode',
                'width': '200px'
            },
            {
                'prop': 'companyName',
                'label': '分公司',
                'width': '150px'
            },
            {
                'prop': 'businessCenterName',
                'label': '经营中心',
                'width': '150px',
                'visible': '2,3,6,7',
            },
            {
                'prop': 'siteName',
                'label': '服务平台',
                'width': '150px',
                'visible': '2,3',
            },
            {
                'label': '内外部客户',
                'prop': 'customerType',
                'type': 'select',
                'options': [
                    { label: '内部客户', value: '1' },
                    { label: '外部客户', value: '2' },
                ],
                'width': '120px',
                'visible': '3,5,7',
            },
            {
                'label': '供应商编码',
                'prop': 'supplierCode',
                'width': '120px'
            },
            {
                'label': '供应商名称',
                'prop': 'supplierNameCn',
                'width': '150px'
            },
            {
                'label': '业务类型',
                'prop': 'businessType',
                'type': 'select',
                'options': [
                    {'label': '运输', 'value': '3'},
                    {'label': '配送', 'value': '4'},
                    {'label': '配送(新)', 'value': '5'},
                ],
                'width': '80px'
            },
            {
                'label': '整改月份',
                'prop': 'month',
                'width': '120px'
            },
            {
                'label': '整改跟进人',
                'prop': 'mipName',
                'width': '120px'
            },
            {
                'label': '下发状态',
                'prop': '_rectificationSendStatus',
                'width': '120px'
            },
            {
                'label': '月度绩效得分',
                'prop': 'countScore',
                'width': '120px'
            },
            {
                'label': '月度绩效得分目标',
                'prop': 'targetScore',
                'width': '150px'
            },
            {
                'label': '绩效等级',
                'prop': 'performanceStarRating',
                'type': 'select',
                'optionNum': 'SUPPLIER_PERFORMANCE_STAR_RATING',
                'options': [],
                'width': '120px'
            },
            {
                'label': '整改提交',
                'prop': 'isSubmitRectificationPlan',
                'type': 'select',
                'options': [
                    { label: '待提交', value: '1' },
                    { label: '已提交', value: '2' },
                ],
                'width': '120px'
            },
            {
                'label': '次月绩效得分',
                'prop': 'nextMonthCountScore',
                'width': '120px'
            },
            {
                'label': '次月整改状况',
                'prop': 'nextRectificationType',
                'type': 'select',
                'optionNum': 'PERFORMANCE_NEXT_MONTH_STATUS',
                'options': [],
                'width': '120px'
            },
        ],
        'action': [
            {
                'type': 'text',
                'label': '查看',
                'size': 'small',
                'event': 'detail',
                'ifHas': '/performRectify-10',
            },
            {
                'type': 'text',
                'label': '提交',
                'size': 'small',
                'event': 'submit',
                'ifHas': '/lsrm/performRectify-20',
            },
            {
                'type': 'text',
                'label': '无需整改原因',
                'size': 'small',
                'event': 'noEditReason',
            },
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100]
    }
};
export default config;